<template>
  <a-spin :spinning="spinning">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="8" :sm="24">
              <a-form-item label="单据编号">
                <span class="ant-form-text">{{result.billNo}}</span>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="供应商">
                <span class="ant-form-text" v-if="result.supplier">{{ result.supplier.name }}</span>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="单据日期">
                <span class="ant-form-text">{{result.billDate}}</span>
              </a-form-item>
            </a-col>
            <a-col :md="24" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-popconfirm title="确认要撤销此购货退货单吗？撤销后，出库数据也将撤销" @confirm="confirm" okText="Yes" cancelText="No">
                  <a-button type="danger" :loading="state.btn" :disabled="state.btn">删除单据</a-button>
                </a-popconfirm>
                <a-button style="margin-left: 8px" @click="toList" type="primary">历史单据</a-button>
                <a-button style="margin-left: 8px" @click="exportExcel">导出</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-divider />
      <div>
        <a-alert type="info" showIcon style="margin-bottom: 10px">
        <span slot="message">
          <span>总数量：{{result.totalQty}}</span>
          <span style="margin-left: 30px">总金额：{{result.totalAmount}}</span>
        </span>
        </a-alert>
        <a-table
          bordered
          :dataSource="result.entries"
          :columns="columns"
          :pagination="false"
          rowKey="id"
          size="middle"
        >
          <div slot="rowIndex" slot-scope="text, record, index">
            {{ index +1 }}
          </div>
          <div slot="goodsName" slot-scope="text, record">
            {{ showGoodsName(record) }}
          </div>

        </a-table>
      </div>
    </a-card>
  </a-spin>
</template>
<script>
import STable from '@/components/table/'
import { getPurchaseRecedeDetail, deletePurchaseRecede } from '@/api/bill'
import { excelPurchaseRecedeDetail } from '@/api/excel'
import { downloadExcel } from '@/utils/util'
import { CODE_FAIL } from '@/store/mutation-types'

export default {
  components: {
    STable
  },
  data () {
    return {

      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: 'rowIndex',
          className: 'text-center',
          scopedSlots: { customRender: 'rowIndex' },
          width: 50
        },
        {
          title: '商品',
          dataIndex: 'goods.name',
          scopedSlots: { customRender: 'goodsName' },
          className: 'text-center',
          width: 200
        },
        {
          title: '单位',
          dataIndex: 'unit.name',
          className: 'text-center',
          width: 50
        },
        {
          title: '仓库',
          dataIndex: 'store.name',
          className: 'text-center',
          width: 130
        },
        {
          title: '数量',
          dataIndex: 'qty',
          className: 'text-center',
          width: 75
        },
        {
          title: '退货单价',
          dataIndex: 'price',
          className: 'text-center',
          width: 75
        },
        {
          title: '退货金额',
          dataIndex: 'amount',
          className: 'text-center',
          width: 75
        },
        {
          title: '备注',
          dataIndex: 'note',
          className: 'text-center',
          width: 155
        },
        {
          title: '关联购货订单号',
          dataIndex: 'srcOrderNo',
          className: 'text-center',
          width: 100
        }
      ],
      result: {},
      spinning: true,
      state: {
        btn: false
      }
    }
  },
  methods: {
    toList () {
      this.$router.push({ name: 'PurchaseRecedeList' })
    },
    exportExcel () {
      excelPurchaseRecedeDetail({ id: this.$route.params['id'] }).then(res => {
        downloadExcel('购货退货单：' + this.result.billNo, res)
      })
    },
    confirm () {
      this.state.btn = true
      deletePurchaseRecede({ id: this.$route.params['id'] }).then((res) => {
        if (res.status !== CODE_FAIL) {
          this.$message.success('删除成功')
          setTimeout(() => {
            this.$router.push({ name: 'PurchaseRecedeList' })
          }, 1000)
        } else {
          this.$message.error(res.message)
        }
      }).finally(() => {
        this.state.btn = false
      })
    },
    showGoodsName (record) {
      return (record.goods.name + (record.goods.type ? '_' + record.goods.type : ''))
    }
  },
  created () {
    const _this = this
    getPurchaseRecedeDetail({ id: _this.$route.params['id'] }).then((res) => {
      if (res.status !== CODE_FAIL) {
        this.result = { ...res.result }
      } else {
        this.$router.push({ name: 'PurchaseRecedeList' })
      }
    }).finally(() => {
      this.spinning = false
    })
  }
}
</script>
<style scoped>
  /deep/ th.text-right, /deep/td.text-right {
    text-align: right !important;
  }
  /deep/ th.text-center, /deep/td.text-center {
    text-align: center !important;
  }
  /deep/ .ant-divider-horizontal {
    margin: 0 0 10px;
  }
</style>
